import {
  APP_INITIALIZER,
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TokenInterceptor } from './core/auth/interceptors/token.interceptor';
import { environment } from '../environments/environment';
import {
  Auth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  initializeAuth,
  onAuthStateChanged,
  provideAuth,
} from '@angular/fire/auth';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { CoreService } from './core/services/core.service';

function waitForAuth(auth: Auth): Promise<void> {
  return new Promise<void>((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      unsubscribe();
      resolve();
    });
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    // provideBrowserGlobalErrorListeners(),
    // provideZoneChangeDetection({ eventCoalescing: true }),
    // provideRouter(routes)
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),

    provideHttpClient(withFetch(), withInterceptors([TokenInterceptor])),

    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    // provideAuth(() => {
    //    const auth = getAuth();
    //     import('firebase/auth').then(({ browserLocalPersistence, setPersistence }) => {
    //     setPersistence(auth, browserLocalPersistence)
    //       .then(() => console.log('[Auth] Persistence set to LOCAL'))
    //       .catch((err) => console.error('[Auth] Persistence error:', err));
    //   });
    //   return auth;}),
    provideAuth(() => {
      console.log('Initialize Auth with persistence...');
      return initializeAuth(getApp(), {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
      });
    }),
    {
      provide: 'waitForAuth',
      useFactory: (auth: Auth) => waitForAuth(auth),
      deps: [Auth],
    },
  ],
};
